import "../UserProfile.css";
import Profiledetails from "./Profiledetails";
import PersonalInformation from "./PersonalInformation";
import DialogNoFooter from "@/app/models/dialogs/DialogNoFooter";
import { t } from "i18next";

interface MyProfileProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  tabSelected?: number;
}

const MyProfile: React.FC<MyProfileProps> = ({
  open,
  setOpen,
  tabSelected,
}) => {

  // ............................... handleClose ................................
  const handleClose = () => setOpen(false);

  return (
    <DialogNoFooter
      close={handleClose}
      open={open}
      title={t("my")}
      subtitle={t("profile")}
    >
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-4">
          <div className="gx-profile-details-card">
            <Profiledetails />
          </div>
        </div>
        <div className="col-span-8">
          <div className="gx-profile-details-card">
            <PersonalInformation selectedTab={tabSelected} />
          </div>
        </div>
      </div>
    </DialogNoFooter>
  );
};

export default MyProfile;
